import React, { useMemo } from 'react';
import cn from 'classnames';
import Link from 'components/UI/Link';
import { useGetDeviceType } from 'utils/hooks';
import { useBreadcrumbs } from './hooks';
import { calculateTitleLengthLimit, pushBreadcrumbsEvent } from './helpers';

import * as styles from './Breadcrumbs.module.scss';

const Breadcrump = ({ current, url, title, deviceType }) => {
  const titleWidthLimit = calculateTitleLengthLimit(title);

  const handleClick = () => {
    pushBreadcrumbsEvent({ url, title, deviceType });
  };

  if (current) {
    return (
      <div className={cn(styles.link, styles.current)} onClick={handleClick}>
        <p
          style={{
            '--mobile-max-width': titleWidthLimit,
          }}
        >
          {title}
        </p>
      </div>
    );
  }

  return (
    <Link className={styles.link} href={url} onClick={handleClick}>
      <p
        style={{
          '--mobile-max-width': titleWidthLimit,
        }}
      >
        {title}
      </p>
    </Link>
  );
};

export default function Breadcrumbs({ visible }) {
  const deviceType = useGetDeviceType();
  const breadcrumbs = useBreadcrumbs();
  const preparedBreadcrumbs = useMemo(() => {
    if (deviceType === 'Mobile') {
      return breadcrumbs?.slice(-2, -1) || breadcrumbs?.[0];
    }
    return breadcrumbs;
  }, [breadcrumbs, deviceType]);

  return (
    <div
      className={cn(styles.wrapper, visible && styles.visible)}
      aria-hidden={!visible}
      inert={!visible ? true : undefined}
    >
      <div className={styles.layout}>
        {preparedBreadcrumbs?.map(({ url, title, current }, i) => (
          <Breadcrump key={url} url={url} title={title} current={current} deviceType={deviceType} />
        ))}
      </div>
    </div>
  );
}
